import MasterRecord from '../MasterRecord'

export default class DelayCode extends MasterRecord {
  public delayRules: string[] = []
}
